import { required, password } from '../../../../utils/validators';

export const constraints = {
  login: [required()],
  password: [required(), password()],
};

export interface FormData {
  login: string;
  password: string;
}
